import { Extension } from '@tiptap/react';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { findDocumentMatches, type FindOptions } from './document-editor-tools';

export const documentFindKey = new PluginKey<{ query: string; active: number; options?: FindOptions }>('documentFind');
export const DocumentFind = Extension.create({
  name: 'documentFind',
  addProseMirrorPlugins() {
    const editor = this.editor;
    return [new Plugin({
      key: documentFindKey,
      state: {
        init: () => ({ query: '', active: -1 }),
        apply: (transaction, previous) => transaction.getMeta(documentFindKey) as typeof previous | undefined ?? previous
      },
      props: {
        decorations(state) {
          const search = documentFindKey.getState(state);
          if (!search?.query) return DecorationSet.empty;
          const { matches } = findDocumentMatches(editor, search.query, search.options);
          return DecorationSet.create(state.doc, matches.map((match, index) => Decoration.inline(match.from, match.to, {
            class: index === search.active ? 'bg-foreground text-background rounded-sm' : 'bg-muted ring-1 ring-foreground/30 rounded-sm'
          })));
        }
      }
    })];
  }
});
